import { Collapse, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { getTranslate } from '../../../localization'
import { Entity } from '../../../types/auditLogs'
import EntityTableEachRow from './EntityTableEachRow'
import useStyles from './styles/index.styles'

interface EntitiesTableProps {
  entities: Entity[]
}

const EntitiesTable: React.FC<EntitiesTableProps> = ({ entities }) => {
  const classes = useStyles()

  const renderData = (
    data: Entity,
    level: number,
    index: number
  ): React.ReactNode => {
    const [open, setOpen] = useState(false)

    return (
      <div key={index}>
        <EntityTableEachRow
          entity={data}
          isExpanded={open}
          setIsExpanded={setOpen}
          level={level}
        />
        {data.subEntities && data.subEntities.length > 0 && (
          <Collapse in={open}>
            {data.subEntities.map((sub: Entity, i) => {
              return renderData(sub, level + 1, i)
            })}
          </Collapse>
        )}
      </div>
    )
  }

  return (
    <>
      <Typography className={classes.contentTitlesHeader} variant="h2">
        {getTranslate('Entities')}
      </Typography>
      {/* entities table */}
      <div className={classes.entitiesContainerWrapper}>
        <div className={classes.entitiesContainer}>
          <div className={classes.entitiesTableHeader}>
            <div>
              <Typography variant="body1">
                {getTranslate('Entity Type')}
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Entity Name')}
              </Typography>
            </div>
            {/* <div>
              <Typography variant="body1">
                {getTranslate('Entity ID')}
              </Typography>
            </div> */}
            <div>
              <Typography variant="body1">
                {getTranslate('Entity Code')}
              </Typography>
            </div>
          </div>
          {/* entities table rows */}
          {entities.map((entity, ii) => renderData(entity, 0, ii))}
        </div>
      </div>
    </>
  )
}

export default EntitiesTable
